var map = {
	"./doc.svg": "59e3",
	"./docx.svg": "903a",
	"./excel.svg": "11a8",
	"./jpeg.svg": "79eb",
	"./jpg.svg": "7bd1",
	"./logo.png": "f464",
	"./mp4.svg": "efdc",
	"./pdf.svg": "874a",
	"./png.svg": "68dc",
	"./word.svg": "fb8f",
	"./xls.svg": "3081",
	"./xlsx.svg": "9364"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b18";